<template>
  <div :v-show="menu">
    <div class="vx-col w-full mb-base">
      <vs-card title="Menu" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <h4 style="margin-left: 10px">Latest APK RF Mobile</h4>
          </div>

          <div class="flex items-center">
            <vs-button
              :to="{ name: 'rfmanagement-list'}"
              class="mb-4 md:mb-0 mr-1"
              icon="remove_red_eye"
            >View Archive APK</vs-button>
          </div>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col lg:w-1/2 w-full">
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Version Number *</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.version_number" disabled />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Version Code</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.version_code" disabled />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Force Update</div>
              <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="menu.force_update" disabled />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/3">Update Notes *</div>
              <div class="vx-col w-2/3">
                <vs-textarea class="w-full" height="100"  v-model="menu.update_notes" disabled />
              </div>
            </div>
          </div>

          <div class="vx-col lg:w-1/2 w-full">
            <div class="vx-row mb-3">
              <div class="vx-col w-1/5"></div>
              <div class="vx-col w-3/5"><strong>Download APK</strong></div>
              <div class="vx-col w-1/5"></div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-1/5"></div>
              <div class="vx-col w-3/5">
                <img v-bind:src="'data:image/jpeg;base64,'+ menu.qrcode" />
              </div>
              <div class="vx-col w-1/5"></div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      isLoading: false,
      menu: {
        file_names:"",
        update_notes: "",
        version_number: "",
        version_code: "",
        qrcode: "",
        force_update: "",
      },
      parents: [],
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    fetchData() {
      this.$http.get("rf/getlatestapk").then((res) => {
            this.menu.version_number = res.data.version_number;
            this.menu.version_code = res.data.version_code;
            this.menu.update_notes = res.data.update_notes;
            this.menu.qrcode = res.data.qrcode;
            this.menu.force_update = res.data.force_update;
        });
    },
    back() {
      this.$router.push({ name: "rfmanagement" });
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>